import { render, staticRenderFns } from "./ProfileTrlData.vue?vue&type=template&id=06292fb1&scoped=true&"
import script from "./ProfileTrlData.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileTrlData.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06292fb1",
  null
  
)

export default component.exports